/*******************************************************************************
 * Copyright (c) 2019-2021 Singularity AI, Inc. - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 ******************************************************************************/
/* import */
import { gql } from 'graphql-tag';
/* AppSync */
import appsyncclient from '../../api/AppSync';
/* GraphQL */

import Message from '../../qg-components/src/libs/Message/index';
const initialState = {
  sideTypeList: [],
  antibodyList: [],
  permission: {
    // uploadImage: false,
    // assign: false,
    // editCase: false,
    // editImage: false
  }
}
/*******************************************************************************
 * main
 ******************************************************************************/
export function settingsPermissionReducer(state = initialState, action) {
  const { type, payload } = action

  switch (type) {

    case 'settings/PermissionLoaded': return { ...state, permission: payload };
    case 'settings/PermissionUpdated': return { ...state, permission: { ...state.permission, ...payload } };

    case 'settings/SideTypeLoaded': return { ...state, sideTypeList: payload };
    case 'settings/SideTypeAdded': return { ...state, sideTypeList: [...state.sideTypeList, payload] };
    case 'settings/SideTypeDeleted': return { ...state, sideTypeList: state.sideTypeList.filter(item => item !== payload) }

    case 'settings/AntibodyLoaded': return { ...state, antibodyList: payload };
    case 'settings/AntibodyAdded': return { ...state, antibodyList: [...state.antibodyList, payload] };
    case 'settings/AntibodyDeleted': return { ...state, antibodyList: state.antibodyList.filter(item => item !== payload) }

    default:
      return state;
  };
};

// Thunk function
// get permission
export async function fetchGetPermission(dispatch, getState) {
  try {
    const response = {
      data: {
        uploadImage: true,
        assign: false,
        editCase: true,
        editImage: false
      }
    }
    dispatch({ type: 'settings/PermissionLoaded', payload: response.data });
  } catch (error) {
    console.log('fetchGetPermission error: ', error);
  };
};
export function fetchUpdatePermission(params) {
  return async dispatch => {
    try {
      dispatch({ type: 'settings/PermissionUpdated', payload: params });
    } catch (error) {
      console.log('fetchUpdatePermission error: ', error);
    };
  }
};

// get sidetype
export async function fetchGetSideType(dispatch, getState) {
  try {
    const response = {
      data: ['Frozen', 'PE', 'FFPE']
    }
    dispatch({ type: 'settings/SideTypeLoaded', payload: response.data });
  } catch (error) {
    console.log('fetchGetSideType error: ', error);
  };
};

// add sidetype
export function fetchAddSideType(params) {
  return async dispatch => {
    try {
      Message.success('添加成功')
      dispatch({ type: 'settings/SideTypeAdded', payload: params });
    } catch (error) {
      console.log('fetchAddSideType error: ', error);
    };
  };
};

// delete side type
export function fetchDeleteSideType(params) {
  return async dispatch => {
    try {
      dispatch({ type: 'settings/SideTypeDeleted', payload: params });
      Message.success('删除成功')
    } catch (error) {
      console.log('fetchDeleteSideType error: ', error);
    };
  };
};


// Thunk function
// get antibody
export async function fetchGetAntibody(dispatch, getState) {
  try {
    const response = {
      data: ['Ki-67', 'PD-L1', 'Her2']
    }
    dispatch({ type: 'settings/AntibodyLoaded', payload: response.data });
  } catch (error) {
    console.log('fetchGetAntibody error: ', error);
  };
};

// add antibody
export function fetchAddAntibody(params) {
  return async dispatch => {
    try {
      Message.success('添加成功')
      dispatch({ type: 'settings/AntibodyAdded', payload: params });
    } catch (error) {
      console.log('fetchAddAntibody error: ', error);
    };
  };
};

// delete antibody
export function fetchDeleteAntibody(params) {
  return async dispatch => {
    try {
      dispatch({ type: 'settings/AntibodyDeleted', payload: params });
      Message.success('删除成功')
    } catch (error) {
      console.log('fetchDeleteAntibody error: ', error);
    };
  };
};